var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgEye = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.5C8.39782 9.5 8.77936 9.34196 9.06066 9.06066C9.34196 8.77936 9.5 8.39782 9.5 8C9.5 7.60218 9.34196 7.22064 9.06066 6.93934C8.77936 6.65804 8.39782 6.5 8 6.5C7.60218 6.5 7.22064 6.65804 6.93934 6.93934C6.65804 7.22064 6.5 7.60218 6.5 8C6.5 8.39782 6.65804 8.77936 6.93934 9.06066C7.22064 9.34196 7.60218 9.5 8 9.5Z",
    fill: "#878787"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.37983 8.27987C1.31675 8.09648 1.31675 7.89727 1.37983 7.71387C1.85621 6.33724 2.75002 5.14343 3.9368 4.29869C5.12358 3.45394 6.54425 3.00032 8.00097 3.00098C9.4577 3.00164 10.878 3.45655 12.064 4.30237C13.25 5.14819 14.1427 6.34281 14.6178 7.71987C14.6809 7.90327 14.6809 8.10248 14.6178 8.28587C14.1417 9.66286 13.2479 10.857 12.061 11.7021C10.8741 12.5471 9.45318 13.0009 7.9962 13.0002C6.53921 12.9996 5.11871 12.5445 3.93258 11.6984C2.74644 10.8523 1.85374 9.65729 1.37883 8.27987H1.37983ZM10.9998 7.99987C10.9998 8.79552 10.6838 9.55859 10.1212 10.1212C9.55855 10.6838 8.79548 10.9999 7.99983 10.9999C7.20419 10.9999 6.44112 10.6838 5.87851 10.1212C5.31591 9.55859 4.99983 8.79552 4.99983 7.99987C4.99983 7.20422 5.31591 6.44116 5.87851 5.87855C6.44112 5.31594 7.20419 4.99987 7.99983 4.99987C8.79548 4.99987 9.55855 5.31594 10.1212 5.87855C10.6838 6.44116 10.9998 7.20422 10.9998 7.99987Z",
    fill: "#878787"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEye, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/eye.9d982589.svg";
export { ForwardRef as ReactComponent };